// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jRrK","status":"styles_status__odLy_"};